"use strict";

var _classCallCheck = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collider = void 0;

var Utils_1 = require("../../../../Utils");

var Enums_1 = require("../../../../Enums");

var Collider = /*#__PURE__*/function () {
  function Collider(container) {
    _classCallCheck(this, Collider);

    this.container = container;
  }

  _createClass(Collider, [{
    key: "isEnabled",
    value: function isEnabled(particle) {
      return particle.particlesOptions.collisions.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact(p1) {
      var container = this.container;
      var pos1 = p1.getPosition();
      var query = container.particles.quadTree.query(new Utils_1.Circle(pos1.x, pos1.y, p1.size.value * 2));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = query[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var p2 = _step.value;

          if (p1 === p2 || !p2.particlesOptions.collisions.enable || p1.particlesOptions.collisions.mode !== p2.particlesOptions.collisions.mode) {
            continue;
          }

          var pos2 = p2.getPosition();
          var dist = Utils_1.Utils.getDistance(pos1, pos2);
          var defaultSize = container.retina.sizeValue;
          var radius1 = Collider.getRadius(p1, defaultSize);
          var radius2 = Collider.getRadius(p2, defaultSize);
          var distP = radius1 + radius2;

          if (dist <= distP) {
            this.resolveCollision(p1, p2);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "resolveCollision",
    value: function resolveCollision(p1, p2) {
      switch (p1.particlesOptions.collisions.mode) {
        case Enums_1.CollisionMode.absorb:
          {
            this.absorb(p1, p2);
            break;
          }

        case Enums_1.CollisionMode.bounce:
          {
            Collider.bounce(p1, p2);
            break;
          }

        case Enums_1.CollisionMode.destroy:
          {
            Collider.destroy(p1, p2);
            break;
          }
      }
    }
  }, {
    key: "absorb",
    value: function absorb(p1, p2) {
      var container = this.container;
      var fps = container.options.fpsLimit / 1000;

      if (p1.size.value === undefined && p2.size.value !== undefined) {
        p1.destroy();
      } else if (p1.size.value !== undefined && p2.size.value === undefined) {
        p2.destroy();
      } else if (p1.size.value !== undefined && p2.size.value !== undefined) {
        if (p1.size.value >= p2.size.value) {
          var factor = Utils_1.Utils.clamp(p1.size.value / p2.size.value, 0, p2.size.value) * fps;
          p1.size.value += factor;
          p2.size.value -= factor;

          if (p2.size.value <= container.retina.pixelRatio) {
            p2.size.value = 0;
            p2.destroy();
          }
        } else {
          var _factor = Utils_1.Utils.clamp(p2.size.value / p1.size.value, 0, p1.size.value) * fps;

          p1.size.value -= _factor;
          p2.size.value += _factor;

          if (p1.size.value <= container.retina.pixelRatio) {
            p1.size.value = 0;
            p1.destroy();
          }
        }
      }
    }
  }], [{
    key: "rotate",
    value: function rotate(velocity, angle) {
      return {
        horizontal: velocity.horizontal * Math.cos(angle) - velocity.vertical * Math.sin(angle),
        vertical: velocity.horizontal * Math.sin(angle) + velocity.vertical * Math.cos(angle)
      };
    }
  }, {
    key: "collisionVelocity",
    value: function collisionVelocity(v1, v2, m1, m2) {
      return {
        horizontal: v1.horizontal * (m1 - m2) / (m1 + m2) + v2.horizontal * 2 * m2 / (m1 + m2),
        vertical: v1.vertical
      };
    }
  }, {
    key: "bounce",
    value: function bounce(p1, p2) {
      var pos1 = p1.getPosition();
      var pos2 = p2.getPosition();
      var xVelocityDiff = p1.velocity.horizontal - p2.velocity.horizontal;
      var yVelocityDiff = p1.velocity.vertical - p2.velocity.vertical;
      var xDist = pos2.x - pos1.x;
      var yDist = pos2.y - pos1.y;

      if (xVelocityDiff * xDist + yVelocityDiff * yDist >= 0) {
        var angle = -Math.atan2(pos2.y - pos1.y, pos2.x - pos1.x);
        var m1 = p1.size.value;
        var m2 = p2.size.value;
        var u1 = Collider.rotate(p1.velocity, angle);
        var u2 = Collider.rotate(p2.velocity, angle);
        var v1 = Collider.collisionVelocity(u1, u2, m1, m2);
        var v2 = Collider.collisionVelocity(u2, u1, m1, m2);
        var vFinal1 = Collider.rotate(v1, -angle);
        var vFinal2 = Collider.rotate(v2, -angle);
        p1.velocity.horizontal = vFinal1.horizontal;
        p1.velocity.vertical = vFinal1.vertical;
        p2.velocity.horizontal = vFinal2.horizontal;
        p2.velocity.vertical = vFinal2.vertical;
      }
    }
  }, {
    key: "destroy",
    value: function destroy(p1, p2) {
      if (p1.size.value === undefined && p2.size.value !== undefined) {
        p1.destroy();
      } else if (p1.size.value !== undefined && p2.size.value === undefined) {
        p2.destroy();
      } else if (p1.size.value !== undefined && p2.size.value !== undefined) {
        if (p1.size.value >= p2.size.value) {
          p2.destroy();
        } else {
          p1.destroy();
        }
      }
    }
  }, {
    key: "getRadius",
    value: function getRadius(particle, fallback) {
      return particle.bubble.radius || particle.size.value || fallback;
    }
  }]);

  return Collider;
}();

exports.Collider = Collider;